import React from 'react';
import { BasicRoundSpinner } from '../shared/assets/BasicRoundSpinner';

// Shell chrome (the loading placeholder), not journey content — see
// .claude/context/journeys.md's "Shell owns the loading placeholder" bullet.
export const DrawerLoading = () => (
  <div
    className="sui-flex sui-h-full sui-w-full sui-items-center sui-justify-center sui-py-8"
    role="status"
    aria-live="polite"
    aria-label="Loading the assistant"
  >
    <BasicRoundSpinner />
  </div>
);
